import * as React from "react"

const OracionIcon = (props) => (
  <svg
    width={67}
    height={67}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M67 15.034v-2.195h-9.437v2.195h3.621v36.932h-3.621v2.195H67v-2.195h-3.621V15.034H67ZM.407 45.228l11.045-24.943c.77-1.72 2.173-2.761 4.075-2.761h.407c1.9 0 3.26 1.041 4.029 2.761l11.045 24.943c.227.498.363.95.363 1.403 0 1.856-1.45 3.35-3.305 3.35-1.63 0-2.716-.95-3.35-2.4l-2.127-4.978H8.646l-2.218 5.205c-.588 1.358-1.765 2.173-3.214 2.173-1.811 0-3.214-1.448-3.214-3.26 0-.497.18-.995.407-1.493Zm19.601-8.782-4.39-10.457-4.392 10.457h8.782ZM34.673 42.738v-.09c0-5.297 4.03-7.741 9.778-7.741 2.445 0 4.21.407 5.93.996v-.407c0-2.853-1.765-4.437-5.205-4.437-1.902 0-3.44.272-4.754.68-.407.135-.678.18-.996.18-1.584 0-2.851-1.222-2.851-2.806 0-1.223.77-2.264 1.855-2.671 2.173-.815 4.527-1.268 7.741-1.268 3.757 0 6.474.996 8.194 2.716 1.81 1.81 2.625 4.482 2.625 7.741v11.045c0 1.857-1.494 3.305-3.35 3.305-1.991 0-3.304-1.403-3.304-2.852v-.045c-1.675 1.856-3.984 3.078-7.333 3.078-4.573 0-8.33-2.625-8.33-7.424Zm15.799-1.584v-1.222c-1.177-.544-2.716-.906-4.391-.906-2.943 0-4.753 1.177-4.753 3.35v.09c0 1.857 1.539 2.943 3.757 2.943 3.214 0 5.387-1.765 5.387-4.255Z"
      fill="#fff"
    />
  </svg>
)

export default OracionIcon
